"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MemoryRepository_1 = require("../../Common/Port/MemoryRepository");
const User_1 = require("../User");
class UserMemRepository extends MemoryRepository_1.MemRepository {
    constructor(cmdHub, evtHub) {
        super();
        this._rtcCmdHub = cmdHub;
        this._eventHub = evtHub;
    }
    userOfId(userId) {
        if (!super.contains(userId)) {
            return User_1.User.INVALID_USER;
        }
        const user = super.load(userId);
        if (user)
            return User_1.User.Builder(this, this._rtcCmdHub, this._eventHub, false, user).build();
        else
            return User_1.User.INVALID_USER;
    }
    async userOfIdAsync(userId) {
        return this.userOfId(userId);
    }
    userOfName(username) {
        const user = super.allItem().find(u => u.username === username);
        if (user)
            return user;
        else
            return User_1.User.INVALID_USER;
    }
    async userOfNameAsync(username) {
        return this.userOfName(username);
    }
    allItem() {
        return super.allItem()
            .map(u => User_1.User.Builder(this, this._rtcCmdHub, this._eventHub, false, u).build());
    }
    async allItemAsync() {
        return await super.allItemAsync();
    }
    exists(username) {
        return super.allItem().findIndex(u => u.username === username) !== -1;
    }
    save(user) {
        if (!this.contains(user.id)) {
            super.save(user);
        }
        else {
            super.update(user);
        }
        user.clearChangeRecord();
    }
}
exports.UserMemRepository = UserMemRepository;
//# sourceMappingURL=UserMemRepository.js.map